import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoginProvider } from './Contexts/Login.Context';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AppRouter } from './AppRouter';
import { APIProvider } from '@vis.gl/react-google-maps';

const queryClient = new QueryClient();
const API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;
const API_URL = import.meta.env.VITE_API_URL;

console.log('Api');
console.log(API_KEY);
console.log(API_URL);

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <GoogleOAuthProvider clientId="857643719746-fd57u6sgkjq5sb0rmrrjg8kam284ql2t.apps.googleusercontent.com">
        <LoginProvider>
          <APIProvider apiKey={API_KEY}>
            <AppRouter />
          </APIProvider>
        </LoginProvider>
      </GoogleOAuthProvider>
    </QueryClientProvider>
  );
}
